import { motion } from "framer-motion";

const BASE = "/brand/product";
const PHOTOS = [
  { src: `${BASE}/open-display.jpg`, alt: "Hot Packz Grabba open 25-jar grabba case on a smoke shop counter", span: "md:col-span-2 md:row-span-2" },
  { src: `${BASE}/single-jar.jpg`, alt: "Hot Packz Grabba jar of premium crushed loose leaf with nicotine warning label", span: "" },
  { src: `${BASE}/jars-pair.jpg`, alt: "Two Hot Packz Grabba jars of premium crushed loose leaf on a shop counter", span: "" },
  { src: `${BASE}/box-angle.jpg`, alt: "Closed Hot Packz Grabba 25-jar grabba case on a counter", span: "" },
  { src: `${BASE}/box-top.jpg`, alt: "Hot Packz Grabba 25-jar grabba case, premium loose leaf, smooth smoke no choke", span: "" },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery" className="py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-12 max-w-2xl"
        >
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-blaze mb-4">On The Shelf</p>
          <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            The <span className="text-fire">packaging</span>
          </h2>
          <p className="text-muted-foreground mt-5 text-base sm:text-lg">
            Premium crushed grabba loose leaf, 25 jars per box. Smooth smoke, no choke. Built to stand out
            on any counter and move off the shelf.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] sm:auto-rows-[220px] lg:auto-rows-[260px] gap-3">
          {PHOTOS.map((p, i) => (
            <motion.figure
              key={p.src}
              data-testid={`gallery-photo-${i}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: Math.min(i * 0.08, 0.4) }}
              className={`group relative overflow-hidden border border-surface-border bg-black ${p.span}`}
            >
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
